import React from "react";
import ReactDOM from "react-dom";
import firebase from "firebase";
import firestore from "firebase/firebase-firestore";
import FileUploader from "react-firebase-file-uploader";
import LinearProgress from '@material-ui/core/LinearProgress';
import { getFileName, getCollection } from '../../constant';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = {
  main: {
    background: '#eee'
  },
  dropzoneUpper: {
    position: 'relative'
  },
  dropzoneCommon: {
    maxWidth: '80%',
    margin: 'auto',
    display: 'block',
    height: 250,
    width: 700,
  },
  dropzone: {
    border: '2px dashed #0087F7',
    borderRadius: 5,
    outline: 'none',
    background: '#fff',
    position: 'relative',
    zIndex: 1
  },
  dropzoneInput: {
    opacity: 0,
    position: 'absolute',
    zIndex: 3,
    left: 0,
    top: 0,
    right: 0
  },
  dropzoneText: {
    opacity: 1,
    zIndex: 2,
  },
  dropzoneInnerText: {
    color: 'rgb(100, 108, 127)',
    lineHeight: '215px',
    textAlign: 'center'
  },
  uploaded: {
    borderRadius: 20,
    backgroundColor: '#999',
    background: 'linear-gradient(to bottom, #bbb, #ddd)',
    overflow: 'hidden',
    width: 120,
    height: 120,
    position: 'relative',
    display: 'inline-block',
    zIndex: 10,
    fontSize: 10,
    margin: 5,
    padding: 5,
  }
}


class ProjectFiles extends React.Component {
  state = {
    filenames: [],
    downloadURLs: [],
    isUploading: false,
    uploadProgress: 0
  };

  handleUploadStart = () =>
    this.setState({
      isUploading: true,
      uploadProgress: 0
    });

  handleProgress = progress => {
    this.setState({
      uploadProgress: progress
    });

    if(progress == 100){
      setTimeout(() => {
        this.setState({
          uploadProgress: 0
        });
      }, 1000)
    }
  }

  handleUploadError = error => {
    this.setState({
      isUploading: false
      // Todo: handle error
    });
    console.error(error);
  };


  handleUploadSuccess = async filename => {

    const { profile, firestore, projectId, newFileUploaded } = this.props;

    const downloadURL = await firebase
      .storage()
      .ref("project-files")
      .child(projectId)
      .child(filename)
      .getDownloadURL();


    firebase
      .storage()
      .ref("project-files")
      .child(projectId)
      .child(filename)
      .getMetadata().then((metaData) => {

        const fileData = { url: downloadURL, parentId: projectId, userName: profile.displayName, userId: profile.id };
        Object.keys(metaData).forEach((key) => {
          if (metaData[key]) {
            fileData[key] = metaData[key];
          }
        })

        firestore.add(
          { collection: getCollection(profile, 'files') },
          fileData
        )
          .then((data) => {
            if (newFileUploaded) {
              newFileUploaded(downloadURL);
            }
          }, (err) => {

          });
      })

    this.setState(oldState => ({
      filenames: [...oldState.filenames, filename],
      downloadURLs: [...oldState.downloadURLs, downloadURL],
      uploadProgress: 100,
      isUploading: false
    }));
  };

  render() {
    if (this.props.small) {
      return <React.Fragment>
        <FileUploader
          style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, margin: 'auto', width: '100%', opacity: 0 }}
          // accept="image/*"
          name="image-uploader-multiple"
          // randomizeFilename
          storageRef={firebase.storage().ref("project-files").child(this.props.projectId)}
          onUploadStart={this.handleUploadStart}
          onUploadError={this.handleUploadError}
          onUploadSuccess={this.handleUploadSuccess}
          onProgress={this.handleProgress}
          multiple
        />
        {/* {this.state.uploadProgress && (this.state.uploadProgress != 0) ? <div style={{ position: 'absolute' }}><CircularProgress variant="static" value={this.state.uploadProgress} /></div> : null} */}
        {this.state.uploadProgress > 0 && <div style={{ position: 'absolute' }}>
          <CircularProgress variant="static" value={this.state.uploadProgress} />
          {this.state.uploadProgress == 100 && <span style={{ position: 'absolute', left: 0 }}><CheckCircleIcon style={{ fontSize: 40 }} color="primary" /></span>}
        </div>}
      </React.Fragment>
    }
    return (
      <div style={styles.main}>
        <div style={styles.dropzoneUpper}>
          <div style={{ ...styles.dropzone, ...styles.dropzoneCommon }} />
          <div style={{ ...styles.dropzoneCommon, ...styles.dropzoneInput, ...styles.dropzoneText }}>
            <p style={styles.dropzoneInnerText} >Drop files here or click to upload.</p>
          </div>
          <FileUploader
            style={{ ...styles.dropzoneInput, ...styles.dropzoneCommon }}
            // accept="image/*"
            name="image-uploader-multiple"
            // randomizeFilename
            storageRef={firebase.storage().ref("project-files").child(this.props.projectId)}
            onUploadStart={this.handleUploadStart}
            onUploadError={this.handleUploadError}
            onUploadSuccess={this.handleUploadSuccess}
            onProgress={this.handleProgress}
            multiple
          />
        </div>

        {
          this.state.uploadProgress
            ?
            <div>
              <p>Progress: {this.state.uploadProgress}</p>
              <LinearProgress variant="determinate" value={this.state.uploadProgress} />
            </div>
            :
            null
        }


        {/* <p>Filenames: {this.state.filenames.join(", ")}</p> */}

        {/* <div>
          {
            this.state.downloadURLs.length ?
              <p style={{marginTop:60}}>Uploaded Files : </p>
              :
              null
          }
          {this.state.downloadURLs.map((downloadURL, i) => {
            if (downloadURL.split('?alt=')[0].match(/\.(jpeg|jpg|gif|png)$/))
              return <img style={styles.uploaded} key={i} src={downloadURL} />
            else {
              return <span key={i} style={styles.uploaded}>{getFileName(downloadURL)}</span>
            }
          })}

        </div> */}
      </div>
    );
  }
}

export default ProjectFiles;